/**
 * The order capture chunk, behind a named function so a caller's decision not
 * to fetch it is observable — the same seam `loadPageViews` gives page views.
 *
 * A literal specifier, since the static-closure checks that keep this out of
 * the always-loaded tier cannot follow a computed one.
 */
export function loadOrderCapture(): Promise<typeof import('@/lib/attribution/startOrderCaptureOnLoad')> {
  return import('@/lib/attribution/startOrderCaptureOnLoad');
}
